import script from "./AlertStatusPill.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertStatusPill.vue?vue&type=script&setup=true&lang=js"

import "./AlertStatusPill.vue?vue&type=style&index=0&id=2ecc4174&lang=scss"

const __exports__ = script;

export default __exports__